import { render, staticRenderFns } from "./EstablishmentLogo.vue?vue&type=template&id=c06017fa&scoped=true&lang=html&"
import script from "./EstablishmentLogo.vue?vue&type=script&lang=js&"
export * from "./EstablishmentLogo.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentLogo.vue?vue&type=style&index=0&id=c06017fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06017fa",
  null
  
)

component.options.__file = "EstablishmentLogo.vue"
export default component.exports